import { connect } from 'react-redux';

import PhysicalLocations from '../../Components/PhysicalLocations';
import WithDefaults from '../WithDefaults';
import { getCompanyStructure } from '../../reducers/company';

const mapStateToProps = (state, ownProps) => ({
  ...ownProps
});

const mapDispatchToProps = (dispatch) => ({
  getCompanyStructure(...args) {
    return getCompanyStructure(dispatch, ...args);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(WithDefaults(PhysicalLocations));
